import { FaRegDotCircle } from "react-icons/fa";

export default function ModalComponent({ data }) {
    return (
        <div className="container-fluid font-monospace">
            {/* <div className="h3 mb-3">Detail</div> */}
            <div className="row">
                <ModalDetail title="position" text={data?.position ?? '-'} />
                <ModalDetail title="chromosome_no" text={data?.chromosome_no ?? '-'} />
                <ModalDetail title="alt" text={data?.alt ?? '-'} />
                <ModalDetail title="end" text={data?.end ?? '-'} />
                <ModalDetail title="filter" text={data?.filter ?? '-'} />
                <ModalDetail title="imprecise" text={data?.imprecise ?? '-'} />
                <ModalDetail title="information" text={data?.information ?? '-'} />
                <ModalDetail title="quality" text={data?.quality ?? '-'} />
                <ModalDetail title="ref" text={data?.ref ?? '-'} />
                <ModalDetail title="st_acc" text={data?.st_acc ?? '-'} />
                <ModalDetail title="svtype" text={data?.svtype ?? '-'} />
                <ModalDetail title="rice_cultivar_th" text={data?.rice_cultivar_th ?? '-'} />
                <ModalDetail title="rice_cultivar_en" text={data?.rice_cultivar_en ?? '-'} />
            </div>
        </div>
    );
}

function ModalDetail({ title, text }) {
    return (
        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div>{title}</div>
            </div>
            <div className="bg-light p-1 rounded" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word", fontFamily: "monospace" }}>
                {text}
            </div>
        </div>
    );
}
